import styled from 'styled-components';

const ContentLayoutStyled = styled.div`
  width: 80vw;
  margin: 80px auto 0 auto;
  .show-markdown-title {
    text-align: center;
    margin-top: 30px;
    p {
      font-size: 10px;
      color: #c3c3c3;
    }
  }
`;

export { ContentLayoutStyled };
